import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export function LogoPetshop() {
  return (
    <motion.div
      initial={{ x: "-100%", y: "-50%", opacity: 1 }}
      animate={{ x: "0%", y: "-50%", opacity: 1 }}
      exit={{ y: "-50%", opacity: 0 }}
      transition={{ duration: 0.25, ease: "easeInOut" }}
      className="absolute left-0 top-1/2"
    >
      <Link to="/hub">
        <img src="/img/logo.png" className="h-8" />
      </Link>
    </motion.div>
  );
}
